'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('question-edit', {
		props: ['question', 'index', 'answerTypes', 'removeQuestion', 'initData'],
		data: function () {
			return {
				accordion: 'question' + this.index,
				accordionHref: '#question' + this.index,
				heading: 'heading' + this.index,
			};
		},
		mounted: function () {
			this.question.el = this.$el;
		},
		template:
			'<div class="panel panel-default">' +
				'<div class="panel-heading" role="tab" :id="heading">' +
					'<h4 class="panel-title">' +
						'<a role="button" data-toggle="collapse" data-parent="#questions" :href="accordionHref" aria-expanded="false" :aria-controls="accordion">' +
							'Question: {{question.question}}' +
						'</a>' +
						'<button type="button" v-on:click="removeQuestion(question)" class="btn btn-xs btn-danger pull-right">{{initData.translations.removeQuestion}}</button>' +
					'</h4>' +
				'</div>' +
				'<div :id="accordion" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="heading">' +
					'<div class="panel-body">' +
						'<div class="row">' +
							'<div class="col-md-8">' +
								'<label for="name">{{initData.translations.question}}</label>' +
								'<input type="text" class="form-control" v-model="question.question" :placeholder="initData.translations.questionPlaceholder" />' +
							'</div>' +
							'<div class="col-md-2 col-xs-6">' +
								'<label for="name">{{initData.translations.startKeyframe}}</label>' +
								'<input type="number" class="form-control" v-model="question.keyframes.start" :placeholder="initData.translations.valueInSecondsPlaceholder" />' +
							'</div>' +
							'<div class="col-md-2 col-xs-6">' +
								'<label for="name">{{initData.translations.stopKeyframe}}</label>' +
								'<input type="number" class="form-control" v-model="question.keyframes.stop" :placeholder="initData.translations.valueInSecondsPlaceholder" />' +
							'</div>' +
						'</div>' +
						'<div class="fg-line mt-3 mb-3">' +
							'<label for="name">{{initData.translations.mediaContent}}</label>' +
							'<question-edit-image class="mb-2" :question="question" :init-data="initData"></question-edit-image>' +
							'<question-edit-video class="mb-2" :question="question" :init-data="initData"></question-edit-video>' +
							'<question-edit-sound class="mb-2" :question="question" :init-data="initData"></question-edit-sound>' +
						'</div>' +
						'<question-edit-answers :question="question" :answer-types="answerTypes" :init-data="initData"></question-edit-answers>' +
					'</div>' +
				'</div>' +
			'</div>',
	});
});
